import { z } from 'zod';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';

export const DimensionDefinition = z
  .object({
    columnHeaderValue: z.string(),
    displayName: z.string(),
    showBeforeEmpsOrApps: z.boolean().optional(),
    insightFormat: z.string().optional(),
    insightWithReferenceFormat: z.string().optional(),
    correspondingRawColumnValue: z.string().nullable(),
    levels: z.array(LevelDefinition),
  })
  .describe('DimensionDefinition');

export type DimensionDefinition = z.infer<typeof DimensionDefinition>;
